import React,{ useState, useEffect }  from 'react'
import {Card} from 'react-bootstrap'
import Sides from '../Bars/Diffjvsp';

import { Helmet } from "react-helmet";
import Button from 'react-bootstrap/Button'
function Jpifelse(){


  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(3)
    } else {
      setWindowpadding(15)
    }
  }

  



return(
    <div>
  <Sides />
      <Helmet>
 
 <title>Difference Between Java and Python ifelse tutorial For Beginners</title>
<meta name="description" content="Difference Between Java and Python ifelse tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and  questions of all technology like java tutorial, python tutorial,python tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,ifelse,tutorial for begineers,Difference Between Java and Python,Difference between program and code,java tutorial for begineers,python tutorial for begineers,C# tutorial for begineers,code,exampler,which online website to learn code,Difference Between Java and python tutorial,code,exampler,java vs python ifelse,java vs Csharp(C#),ifelse"/>
<link rel="canonical" href="https://www.codeexampler.com/java-vs-python-if-else" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Difference Between Java and Python if-else </h1>
    <div className="first">
        <a href="/java-vs-python-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-vs-python-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-3 para">when if the condition is true so on that time target of the will be executed
     but if the condition is false so if it exists and the target of the else will be executed</p>

    <h2 className="mt-4 mh2">
Java if else syntax :</h2>
   
   
    
    <Card className='inde' border='primary m-4'>
  <Card.Header as="h5">Java if else statement syntax :</Card.Header>
  <Card.Body>
    <Card.Text>
   <p><span className="re"> if (condition)</span><br/>
    &#123;<br/>
Statement;<br/>
&#125;<br/>
<span className="bl">else</span><br/>
&#123;<br/>
Statement;<br/>
&#125;<br/>
</p>
    </Card.Text>
  </Card.Body>
</Card>

<h2 className="mt-4 mh2">
Python If else statement Syntax</h2>
          

<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">Python if else statement example</Card.Header>
  <Card.Body>
    <Card.Text>
    <p><span className="yl">if (condition)</span><br/>
Statement;<br/>
<span className="gr">else</span><br/>
Statement;<br/>
</p>
    </Card.Text>
  </Card.Body>
</Card>

<h2 className="mt-4 mh2">
Difference Between Java and Python If else Example</h2>

<h3 className="mt-4">Java If else Example:</h3>


<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">Q-Write a program to input a number and check this value is greater in Java if-else Statement Example?</Card.Header>
  <Card.Body>
    <Card.Text>
   <p><span className="bl">public</span> class <span className="re">ifelse_example</span> &#47;&#47; <span className="gr">class</span> is a <span className="yl">keyword</span><br/>
   &#123;<br/>
   <span className="bl">public</span> static void main(String[] args) <br/>
&#123;<br/>
<span className="yl">int</span> <span className="re">a</span>,<span className="gr">b</span>;<br/>
<span className="re">a</span>=100;<span className="gr">b</span>=200;<br/>
<span className="yl">if</span>(<span className="re">a</span><span className="bl">&#62;</span><span className="bl">b</span>)<br/>
&#123;<br/>
System.out.<span className="yl">println</span>("a is greater than b");<br/>
&#125;<br/>
<span className="gr">else</span><br/>
&#123;<br/>
System.out.<span className="yl">println</span>("b is greater than a");<br/>
&#125;<br/>
&#125;<br/>
&#125;<br/>
</p>
    </Card.Text>
  </Card.Body>
  <Card.Footer>Output-<br /> b is greater than a</Card.Footer>
</Card>
<h3 className="mt-4">Python ifelse Example</h3>

<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">Q-Write a program to find out which no is greater between two numbers in Python Example?
</Card.Header>
  <Card.Body>
    <Card.Text>
    <p>
    <span className="bl">a</span>=40;<span className="yl">b</span>=50;<br/>
    <span className="re">if</span>(<span className="yl">a</span><span className="bl">&#62;</span><span className="gr">b</span>):<br/>
     print("greater=",<span className="re">a</span>);<br/>
     <span className="bl">else</span>:<br/>
    print("greater=",<span className="gr">b</span>);
</p>
    </Card.Text>
  </Card.Body>
  <Card.Footer>Output-<br/>greater= 50</Card.Footer>
</Card>

<h1 className="mt-5">  </h1>
       
<div className="back">
        <a href="/java-vs-python-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-vs-python-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div>
    </div>
)

}
export default Jpifelse;